/**
 * The version of the SmartFilter core. During publish, this file is overwritten by recordVersionNumber.ts with the same version that is used for the NPM publish.
 */
export const SmartFilterCoreVersion = "9.30.0";
//# sourceMappingURL=version.js.map